import React from 'react';
import { Button } from '../ui-kit';
import PulseLoader from 'react-spinners/PulseLoader';

const loaderCss = { display: 'inline-block' };

const styleObject = {
  minWidth: '140px'
};

export const ButtonLoadingContent = () => <PulseLoader color="#fff" size="7px" css={loaderCss} />;

const SaveButton = ({ hasUnsavedChanges, isSaving, onClick, label, style = 'success', className }) => {
  let text = null;
  if (label) {
    text = label; // override
  } else if (isSaving) {
    text = I18n.t('save'); // shorter which reduces resizing
  } else if (hasUnsavedChanges) {
    text = I18n.t('save');
  } else {
    text = I18n.t('saved');
  }

  return (
    <Button
      variant={hasUnsavedChanges ? style : 'outline-secondary'}
      disabled={!hasUnsavedChanges || isSaving}
      className={className}
      onClick={onClick}
      style={styleObject}
    >
      {text} {isSaving && <ButtonLoadingContent />}
    </Button>
  );
};

export default SaveButton;
